import logo from "../images/cape.png";

const PageBanner = ({ title, subtitle, rightContent }) => {
  return (
    <header style={navBar}>
      <div style={navLeft}>
        <img src={logo} alt="Logo" style={logoStyle} />
        <div>
          <div style={titleStyle}>{title}</div>
          {subtitle && <div style={subtitleStyle}>{subtitle}</div>}
        </div>
      </div>

      {/* Right-side content like Logout */}
      {rightContent}
    </header>
  );
};

export default PageBanner;

const navBar = {
  height: "112px",
  background: "#0E5580",
  display: "flex",
  alignItems: "center",
  padding: "0 48px"
};

const navLeft = {
  display: "flex",
  alignItems: "center",
  gap: "18px"
};

const logoStyle = {
  height: "72px"
};

const titleStyle = {
  fontSize: "26px",
  fontWeight: "600",
  color: "#FFD700"
};

const subtitleStyle = {
  fontSize: "14px",
  color: "#ffffff",
  opacity: 0.9
};

